import { GridViewType } from '../../../../shared/components/grid/grid-config';
import { ScheduledPaymentModel } from '../../models/scheduled-payment.model';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { scheduledPaymentActions } from './customer-details-scheduled-payments-actions';

export const CustomerScheduledPaymentsConfig: GridViewType<ScheduledPaymentModel> = {
  enableColumnFilters: true,
  columns: [
    {
      code: 'actions',
      isActionColumn: true,
      actions: scheduledPaymentActions
    },
    {
      code: 'status',
      label: 'Status',
      filterType: 'select',
      template: 'statusTemplate'
    },
    {
      code: 'paymentPlanType',
      label: 'Plan Type',
      filterType: 'select',
      getValue: (row: ScheduledPaymentModel) => {
        return row.paymentPlanType === 'weekly_amount' ? 'Recurring' : 'Payment Plan';
      }
    },
    {
      code: 'nextExecutionDate',
      label: 'Next Payment Date',
      getValue: (row: ScheduledPaymentModel) => {
        if (!row.nextExecutionDate) return 'N/A';
        const terminalStatuses = ['completed', 'cancelled', 'failed'];
        if (terminalStatuses.includes(row.status)) return 'N/A';
        
        // Format the date manually to avoid DatePipe errors with 'N/A'
        const date = new Date(row.nextExecutionDate);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
      }
    },
    {
      code: 'calculatedWeeklyAmount',
      label: 'Weekly Amount',
      pipes: [
        { pipe: CurrencyPipe }
      ]
    },
    {
      code: 'totalAmount',
      label: 'Total Amount',
      getValue: (row: ScheduledPaymentModel) => {
        // For Weekly Recurring plans, show N/A
        if (row.paymentPlanType === 'weekly_amount') {
          return 'N/A';
        }
        // Format currency manually for Payment Plan types
        const amount = row.totalAmount || 0;
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
      }
    },
    {
      code: 'capitalCostPercentage',
      label: 'Capital Cost %',
      getValue: (row: ScheduledPaymentModel) => {
        if (row.capitalCostEnabled) {
          return `${row.capitalCostPercentage || 0}%`;
        }
        return 'N/A';
      }
    },
    // {
    //   code: 'totalWithCapitalCost',
    //   label: 'Total + Capital',
    //   pipes: [
    //     { pipe: CurrencyPipe }
    //   ],
    //   getValue: (row: ScheduledPaymentModel) => {
    //     const baseTotal = row.totalAmount || 0;
    //     if (row.capitalCostEnabled) {
    //       return baseTotal + (row.capitalCostAmount || 0);
    //     }
    //     return baseTotal;
    //   }
    // },
    {
      code: 'progress',
      label: 'Progress',
      getValue: (row: ScheduledPaymentModel) => {
        // For Weekly Recurring plans, show N/A
        if (row.paymentPlanType === 'weekly_amount') {
          return 'N/A';
        }
        const completed = row.executionCount || 0;
        const total = row.numberOfWeeks || 0;
        const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
        return `${completed}/${total} (${percentage}%)`;
      }
    },
    // {
    //   code: 'referenceNumber',
    //   label: 'Reference #'
    // }
  ]
};
